<template>
    <div class="color-circle" :data-color="color"/>
</template>

<script>
    export default {
        name: 'touchpoint-overview-icon-circle',
        props: {
            color: {
                type: String,
                default: 'blue' //blue/green
            }
        }
    }
</script>

<style scoped lang="scss" src="../../../Style/touchpoint-overview-icon-circle.scss" />